<template>
    <div class="right-section">
        <div class="position-absolute top-0 end-0 text-black-50">
            <h5 v-if="showMode=='dst'"><i class="bi bi-box-arrow-up-right"></i></h5>
            <h5 v-else><i class="bi bi-box-arrow-in-down-right"></i></h5>
        </div>
        <AnchorDetail v-if="target"
                :target="detailTarget"
                :showMode="showMode"
                :bucketname="bucketname"
                @src-selected="srcSelected($event)"
                @update-anchors="updateAnchors($event)"
        />
        <AnchorList v-else
            :anchors="anchors"
            :showMode="showMode"
            @src-selected="srcSelected($event)"
            @switch-mode="switchMode($event)"
        />
    </div>
</template>

<script>
import AnchorList from "./AnchorList.vue";
import AnchorDetail from "./AnchorDetail.vue";

export default {
    name: "RightPanel",
    components: {AnchorList, AnchorDetail},
    props: {
        target: { type: Object, required: false, default: null},
        anchors: { type: Array, required: false },
        showMode: { type:String, required: true },
        bucketname: {type:String, required: true },
    },
    data() {
        return {
            detailTarget: null,
        }
    },
    mounted: function() {
    },
    methods: {
        srcSelected(target){
            this.$emit('src-selected', target);
        },
        switchMode(newMode) {
            this.$emit('switch-mode', newMode);
        },
        updateAnchors() {
            this.$emit('update-anchors');
        },
    },
    watch: {
        anchors: function() {
            console.log(this.anchors);
        },
        target: function(t){
            console.log('target changed');
            console.log(t);
            this.$nextTick( function(){
                this.detailTarget = t;
            });
        },
    }
}
</script>

<style scoped>
.right-section {
  height: 93vh;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid;
  border-radius: 5px;
  position: relative;
}
</style>
